export class OrcStatus {
  id: number;
  descricao: string;
  tipo: number;
}
